import { render, staticRenderFns } from "./RotateSquare5.vue?vue&type=template&id=90fe1bb0&scoped=true&"
import script from "./RotateSquare5.vue?vue&type=script&lang=js&"
export * from "./RotateSquare5.vue?vue&type=script&lang=js&"
import style0 from "./RotateSquare5.vue?vue&type=style&index=0&id=90fe1bb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90fe1bb0",
  null
  
)

export default component.exports